import { c as _c } from "react/compiler-runtime";
import { FilterToolbarClearAll } from "@components/common/faro-table/faro-table-filter/filter-toolbar-clear-all";
import { FilterToolbarQuickSearch } from "@components/common/faro-table/faro-table-filter/filter-toolbar-quick-search";
import { FilterToolbarTitle } from "@components/common/faro-table/faro-table-filter/filter-toolbar-title";
import { Stack } from "@mui-wrapper";
/** Toolbar to show for filter chips in large screens */
export function FilterToolbarLargeScreen(t0) {
  const $ = _c(9);
  const {
    filterChipComponents
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      justifyContent: "space-between",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      height: "28px",
      alignItems: "center",
      gap: "8px",
      my: "17px",
      justifyContent: "flex-start"
    };
    t3 = <FilterToolbarTitle />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FilterToolbarClearAll />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== filterChipComponents) {
    t5 = <Stack direction="row" sx={t2}>{t3}{filterChipComponents}{t4}</Stack>;
    $[4] = filterChipComponents;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FilterToolbarQuickSearch />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <Stack direction="row" sx={t1}>{t5}{t6}</Stack>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}